export default "__VITE_ASSET__IDjbWckz__"